import { render, staticRenderFns } from "./sea.vue?vue&type=template&id=9b566240&scoped=true&"
import script from "./sea.vue?vue&type=script&lang=js&"
export * from "./sea.vue?vue&type=script&lang=js&"
import style0 from "./sea.vue?vue&type=style&index=0&id=9b566240&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b566240",
  null
  
)

export default component.exports